import Vue from "vue";
import Router from "vue-router";
import findLast from "lodash/findLast";
import { notification } from "ant-design-vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { check, isLogin } from "./utils/auth";

Vue.use(Router);
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/user",
      hideInMenu: true,
      component: () =>
        import(/* webpackChunkName: "layout" */ "./layouts/UserLayout"),
      children: [
        {
          path: "/user",
          redirect: "/user/login"
        },
        {
          path: "/user/login",
          name: "login",
          component: () =>
            import(/* webpackChunkName: "user" */ "./views/User/Login")
        },
        {
          path: "/user/register",
          name: "register",
          component: () =>
            import(/* webpackChunkName: "user" */ "./views/User/Register")
        },
        {
          path: "/user/register-result",
          name: "register.result",
          component: () =>
            import(/* webpackChunkName: "user" */ "./views/User/RegisterResult")
        }
      ]
    },
    {
      path: "/",
      meta: { authority: ["client", "admin"] },
      component: () =>
        import(/* webpackChunkName: "layout" */ "./layouts/BasicLayout"),
      children: [
        // dashboard
        {
          path: "/",
          redirect: "/device/active/list"
        },
        {
          path: "/dashboard",
          name: "dashboard",
          meta: { icon: "dashboard", title: "Menu.dashboard" },
          component: { render: h => h("router-view") },
          children: [
            {
              path: "/dashboard/overview",
              name: "overview",
              meta: { title: "Menu.Monitor" },
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Dashboard/OverView")
            },
            {
              path: "/dashboard/aichat",
              name: "aichat",
              meta: { title: "Menu.Robot" },
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Dashboard/Aichat")
            },
            {
              path: "/dashboard/test",
              hideInMenu: true,
              name: "test",
              meta: { title: "测试页" },
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Dashboard/Test")
            }
          ]
        },
        // Exception
        {
          path: "/exception",
          name: "exception",
          component: { render: h => h("router-view") },
          redirect: "/exception/403",
          meta: { title: "异常页", icon: "warning", authority: ["admin"] },
          children: [
            {
              path: "/exception/403",
              name: "exception403",
              component: () =>
                import(/* webpackChunkName: "exception" */ "@/views/Exception/403"),
              meta: { title: "403" }
            },
            {
              path: "/exception/404",
              name: "exception404",
              component: () =>
                import(/* webpackChunkName: "exception" */ "@/views/Exception/404"),
              meta: { title: "404" }
            },
            {
              path: "/exception/500",
              name: "exception500",
              component: () =>
                import(/* webpackChunkName: "exception" */ "@/views/Exception/500"),
              meta: { title: "500" }
            }
          ]
        },
    // form
        {
          path: "/setting",
          name: "setting",
          component: { render: h => h("router-view") },
          hideInMenu: true,
          meta: { icon: "form", title: "设备详情" },
          children: [
            {
              path: "/setting/userinfo/edit",
              name: "userinfoedit",
              component: () =>
                import(/* webpackChunkName: "form" */ "./views/Forms/UserForm")
            }
          ]
        },
        // notification
        {
          path: "/notification",
          name: "notification",
          component: { render: h => h("router-view") },
          hideInMenu: true,
          meta: { icon: "form", title: "通知" },
          children: [
            {
              path: "/notification/sos",
              name: "sos",
              component: () =>
                import(/* webpackChunkName: "form" */ "./views/Location/SosPosition")
            }
          ]
        },                     
        {
          path: "/device",
          name: "device",
          meta: { icon: "dashboard", title: "Menu.Device", authority: ["client", "admin"] },
          component: { render: h => h("router-view") },
          children: [
            {
              path: "/device/active/list",
              name: "active_device_list",
              meta: { title: "Menu.DeviceList" },
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Device/DeviceList")
            },
            {
              path: "/device/summary",
              name: "device_summary",
              meta: { title: "设备信息" },
              hideInMenu: true,
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Device/DeviceSummary")
            },
            {
              path: "/device/settings",
              name: "device_settings",
              meta: { title: "设备设置" },
              hideInMenu: true,
              component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Device/DeviceSetting")
            }            
          ]
        }
      ]
    },
    {
      path: "/403",
      name: "403",
      hideInMenu: true,
      component: () =>
        import(/* webpackChunkName: "exception" */ "@/views/Exception/403")
    },
    {
      path: "*",
      name: "404",
      hideInMenu: true,
      component: () =>
        import(/* webpackChunkName: "exception" */ "@/views/Exception/404")
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    NProgress.start();
  }
  const record = findLast(to.matched, record => record.meta.authority);
  if (record && !check(record.meta.authority)) {
    if (!isLogin() && to.path !== "/user/login") {
      next({
        path: "/user/login"
      });
    } else if (to.path !== "/403") {
      notification.error({
        message: "403",
        description: "You do not have permission to access, please contact the administrator for consultation."
      });
      next({
        path: "/403"
      });
    }
    NProgress.done();
  }

  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
